import { render, staticRenderFns } from "./RideitCommunications.vue?vue&type=template&id=1f533b5d&scoped=true"
import script from "./RideitCommunications.vue?vue&type=script&lang=ts"
export * from "./RideitCommunications.vue?vue&type=script&lang=ts"
import style0 from "./RideitCommunications.vue?vue&type=style&index=0&id=1f533b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f533b5d",
  null
  
)

export default component.exports